import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeLimiteCaractere2'
})
export class PipeLimiteCaractere2 implements PipeTransform {
    transform(value: string): string {
        if(value == null || value == undefined){
            return ''
        }
        if(value && value.length > 15){
            return value.substr(0, 15) + '...';
        }else{
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeLimiteCaractere2.ts